module.exports = __webpack_public_path__ + "img/mm2.75496ebb.jpg";